import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface Props {
  listItems: string[];
  title: string;
  subTitle: string;
}
const OpenEndorseProductsTitle = ({ listItems, title, subTitle }: Props) => (
  <Box
    width="100%"
    display="flex"
    flexDirection="column"
    alignItems="center"
    py={{ xs: 3.75, md: 7 }}
  >
    <Box mb={{ xs: 2.5, md: 5 }}>
      <Typography
        variant="h1"
        component="h2"
        textAlign="center"
        fontSize={{ xs: "38px", sm: "52px", md: "62px" }}
        lineHeight="32px"
      >
        {title}
      </Typography>
    </Box>
    <Box mb={2.5} px={3} maxWidth="533px">
      <Typography
        variant="h4"
        component="h3"
        textAlign="center"
        fontSize={{ xs: "22px", sm: "25.5px", md: "28.5px" }}
        lineHeight="32px"
      >
        {subTitle}
      </Typography>
    </Box>
    <Box
      display="flex"
      justifyContent="center"
      flexWrap="wrap"
      px={{ xs: 2, sm: 0 }}
      mb={{ xs: 3 }}
    >
      <Typography
        variant="body1"
        fontStyle="italic"
        fontWeight="350"
        fontSize="18px"
      >
        {listItems[0] ? listItems[0].trim() : ""}
      </Typography>
      <li
        style={{
          paddingLeft: "1em",
          fontFamily: "ABC Favorit Book",
          fontStyle: "italic",
          fontSize: "18px",
        }}
      >
        {listItems[1] ? listItems[1].trim() : ""}
      </li>

      <li
        style={{
          paddingLeft: "1em",
          fontFamily: "ABC Favorit Book",
          fontStyle: "italic",
          fontSize: "18px",
        }}
      >
        {listItems[2] ? listItems[2].trim() : ""}
      </li>
    </Box>
  </Box>
);

export default React.memo(OpenEndorseProductsTitle);
